import { ChargeFilters, QueryResult } from '@/type';
import api from '../API';

export default {
  findAll(
    customerId: number,
    filters: ChargeFilters = {},
  ): Promise<QueryResult> {
    return api
      .get(`customers/${customerId}/charges`, { params: filters })
      .then(response => response.data);
  },
};
